<template>
  <div class="flex flex-col">
    <a href="https://www.getbanyan.com/" target="_blank">
    <img
      class="cursor-pointer mx-auto mt-8 mb-10 xl:block hidden"
      :src="require('@/assets/images/black-logo.png')"
      width="220"
      height="40"
    />
    <img
      class="cursor-pointer mx-auto mt-8 mb-10 xl:hidden block"
      :src="require('@/assets/images/white-logo.png')"
      width="220"
      height="40"
    />
    </a>

    <ul>
      <li
        v-for="(item, key) in items"
        :key="key"
        :class="[item.to === $route.path ? 'xl:border-blue-500 border-gray-500 bg-gray-100 ': 'xl:border-white border-transparent']"
        class="cursor-pointer flex flex-col items-start justify-between border-l-4"
      >
        <div
          :class="[item.toggle ? 'hover:bg-opacity-0':'hover:bg-opacity-0']"
          class="flex items-center hover:bg-gray-50 xl:hover:bg-opacity-100 px-12 justify-between w-full py-2"
          @click="toggleAndNavigate(item)"
        >
          <div>
            <span class="xl:text-gray-400 text-gray-500 text-base font-bold">{{
              item.title
            }}</span>
          </div>
          <div class="xl:text-gray-400 text-gray-500">
            <i
              class="fa"
              v-if="item.child.length > 0"
              :class="[item.toggle ? 'fa-chevron-down' : 'fa-chevron-right']"
            ></i>
          </div>
        </div>

        <slide-up-down :active="item.toggle" class="w-full" v-if="item.child" :duration="200">
          <ul class="">
            <li
              v-for="(child, index) in item.child"
              :key="index"
              @click.stop="toggleAndNavigate(child)"
              class="ml-14 pl-4 py-2 flex items-center hover:bg-gray-50 xl:hover:bg-opacity-100 "
              :class="[child.to === $route.path ? 'border-l-4 xl:border-blue-500 border-gray-500 bg-gray-100 ': 'border-l-4 xl:border-gray-100 border-gray-100 border-opacity-40']"
            >
              <span
                class="xl:text-gray-400 text-gray-500 cursor-pointer pl-2 text-base"
                >{{ child.label }}</span
              >
            </li>
          </ul>
        </slide-up-down>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      items: [
        {
          title: "Home",
          to: "/",
          child: [],
        },
        {
          title: "Product",
          to: "",
          toggle: false,
          child: [
            {
              label: "Banyan Receipt API",
              to: "/client/API",
            },
            {
              label: "Banyan SDK",
              to: "/client/SDK",
            },
            {
              label: "Banyan Confirm API",
              to: "/client/confirm-api",
            }
          ],
        },
        {
          title: "Merchant",
          toggle: false,
          to: "",
          child: [
            {
              label: "API",
              to: "/merchant/API",
            },
            {
              label: "SFTP",
              to: "/merchant/SFTP",
            },
          ],
        },
        {
          title: "Existing Integrations",
          to: "/existing-integrations",
          child: [],
        },
      ],
    };
  },
  methods: {
    ...mapMutations("common", ["setPanel", "setBurger"]),
    toggleAndNavigate(item) {
      // eslint-disable-next-line no-prototype-builtins
      if (item.hasOwnProperty("toggle")) {
        return (item.toggle = !item.toggle);
      }

      this.setBurger(false);
      this.setPanel(false);

      if (item.to !== "") {
        this.$router.push(item.to).catch(() => {});
      }
    }
  },
};
</script>
